import {
  DdEventCategory,
  DdEventType,
  Logger,
} from '@/features/logging/logger';
import { ProxyMessage } from '@/features/wrapper-proxy/proxy-message';

export const logProviderMessages = (
  data: ProxyMessage | MessageEvent,
  loggerOption: MessageEventsLoggerOptions,
) => {
  const { name, logType, useCase, inclusions } = loggerOption;

  if (!data?.type || !inclusions.includes(data.type)) return;

  switch (logType) {
    case 'error':
      Logger.logRumError({
        name,
        useCase,
        eventType: DdEventType.Error,
        payload: {
          ...data,
        },
      });
      break;
    case 'info':
      Logger.logRumAction({
        name: `${name} - ${data.type.replace('GC/', '')}`,
        useCase,
        eventType: DdEventType.Info,
        payload: {
          ...data,
        },
      });
      break;
  }
};

export const logUntrustedWrapperMessage = (event: MessageEvent) => {
  const type = event?.data?.type;

  if (typeof type !== 'string') {
    return;
  }

  Logger.logRumAction({
    name: 'WRAPPER_MESSAGE - UNTRUSTED',
    useCase: DdEventCategory.WraperMessages,
    eventType: DdEventType.Info,
    payload: {
      type,
      origin: event.origin,
      sameWindow: event.source === window,
    },
  });
};

export const providerMessagesInclusion = [
  'GC/RESET_GAME',
  'GC/SET_PROVIDER_ERROR',
  'GC/FETCH_GAME_FAILURE',
  'GC/UPDATE_GEOCOMPLY_FAILURE',
  'GC/GEOLOCATION_FAILURE',
  'GC/GEOLOCATION_REJECTED',
  'GC/GEOLOCATION_INVALIDATED',
  'GC/CONTEXT_PARAM_MISSING',
];
export const wrapperMessagesInclusions = [
  'GL/RELOAD_BALANCE',
  'GL/AUTO_SPIN_STOP',
  'GL/AUTO_SPIN_RESUME',
];

export type MessageEventsLoggerOptions = {
  logType: 'error' | 'info';
  useCase: DdEventCategory;
  name: 'PROVIDER_MESSAGE' | 'PROVIDER_ERROR' | 'WRAPPER_MESSAGE';
  inclusions: typeof providerMessagesInclusion;
};
